import { NONINPUT } from './dropdown.service';
import { Injectable } from '@angular/core';
/** Default dropdown configuration */
var DropdownConfig = (function () {
    function DropdownConfig() {
        /** default dropdown auto closing behavior */
        this.autoClose = NONINPUT;
        /** is keyboard navigation enabled by default */
        this.keyboardNav = false;
    }
    return DropdownConfig;
}());
export { DropdownConfig };
DropdownConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DropdownConfig.ctorParameters = function () { return []; };
//# sourceMappingURL=dropdown.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/dropdown/dropdown.config.js
// module id = 105
// module chunks = 3